/* ============================================================
   Patipet — mevcut ürün sayfası davranışı (Aşama 1)
   Galeri (Swiper), collapsible rows, benefit tabs, FAQ akordiyonu,
   sayaç animasyonu, sepete ekleme.
   ============================================================ */
(function () {
  'use strict';
  var scope = document;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1 · Galeri ---------- */
  function initGallery() {
    var main = scope.querySelector('[data-st-gallery]');
    var thumbs = scope.querySelector('[data-st-thumbs]');
    var zone = scope.querySelector('.st_pi-thumbs-zone');
    if (!main || typeof Swiper === 'undefined') return;

    var thumbSwiper = null;
    if (thumbs) {
      thumbSwiper = new Swiper(thumbs, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        centerInsufficientSlides: true,
        navigation: {
          prevEl: '[data-st-thumb-prev]',
          nextEl: '[data-st-thumb-next]',
          disabledClass: 'swiper-button-disabled',
          lockClass: 'swiper-button-lock'
        }
      });
      if (zone) zone.classList.add('st_pi-thumbs-ready');
    }

    new Swiper(main, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 350,
      navigation: { prevEl: '[data-st-arrow-prev]', nextEl: '[data-st-arrow-next]', disabledClass: 'swiper-button-disabled' },
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Önceki görsel',
        nextSlideMessage: 'Sonraki görsel',
        firstSlideMessage: 'İlk görsel',
        lastSlideMessage: 'Son görsel'
      },
      thumbs: thumbSwiper ? { swiper: thumbSwiper } : undefined
    });
  }

  /* ---------- 2 · Collapsible rows (<details> animasyonu) ---------- */
  function initRows() {
    Array.prototype.forEach.call(scope.querySelectorAll('.st_pi-row'), function (row) {
      var summary = row.querySelector('summary');
      var body = row.querySelector('.st_pi-row-body');
      if (!summary || !body) return;

      summary.addEventListener('click', function (e) {
        if (reduce || row.closest('[data-pp-motion="false"]')) return;
        e.preventDefault();
        if (row.classList.contains('st_pi-row--animating')) return;

        if (row.open) {
          row.classList.add('st_pi-row--animating', 'st_pi-row--closing');
          var onEndClose = function (ev) {
            if (ev.propertyName !== 'grid-template-rows') return;
            body.removeEventListener('transitionend', onEndClose);
            row.open = false;
            row.classList.remove('st_pi-row--animating', 'st_pi-row--closing');
          };
          body.addEventListener('transitionend', onEndClose);
        } else {
          row.classList.add('st_pi-row--animating');
          row.open = true;
          row.classList.add('st_pi-row--opening');
          requestAnimationFrame(function () { row.classList.remove('st_pi-row--opening'); });
          var onEndOpen = function (ev) {
            if (ev.propertyName !== 'grid-template-rows') return;
            body.removeEventListener('transitionend', onEndOpen);
            row.classList.remove('st_pi-row--animating');
          };
          body.addEventListener('transitionend', onEndOpen);
        }
      });
    });
  }

  /* ---------- 3 · Benefit tabs ---------- */
  function initTabs() {
    var nav = scope.querySelector('[data-pp-tabs]');
    if (!nav) return;
    var btns = Array.prototype.slice.call(nav.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(scope.querySelectorAll('[role="tabpanel"]'));

    function select(i) {
      btns.forEach(function (b, k) {
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
        b.tabIndex = k === i ? 0 : -1;
      });
      panels.forEach(function (p, k) { p.classList.toggle('is-active', k === i); });
    }
    btns.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });

    nav.addEventListener('keydown', function (e) {
      var cur = btns.indexOf(document.activeElement);
      if (cur < 0) return;
      var next = null;
      if (e.key === 'ArrowRight') next = (cur + 1) % btns.length;
      else if (e.key === 'ArrowLeft') next = (cur - 1 + btns.length) % btns.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = btns.length - 1;
      if (next === null) return;
      e.preventDefault(); select(next); btns[next].focus();
    });

    var prev = scope.querySelector('[data-pp-tab-prev]');
    var nxt = scope.querySelector('[data-pp-tab-next]');
    function currentIndex() { return btns.findIndex(function (b) { return b.getAttribute('aria-selected') === 'true'; }); }
    if (prev) prev.addEventListener('click', function () { var i = currentIndex(); select((i - 1 + btns.length) % btns.length); });
    if (nxt) nxt.addEventListener('click', function () { var i = currentIndex(); select((i + 1) % btns.length); });

    select(0);
  }

  /* ---------- 4 · FAQ akordiyonu (tek açık davranışı) ---------- */
  function initFaq() {
    var list = scope.querySelector('[data-pp-faq]');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('.pp-faq-item'));

    function close(item) {
      var a = item.querySelector('.pp-faq-a');
      var q = item.querySelector('.pp-faq-q');
      a.style.height = a.scrollHeight + 'px';
      requestAnimationFrame(function () { a.style.height = '0px'; });
      item.classList.remove('is-open');
      q.setAttribute('aria-expanded', 'false');
    }
    function open(item) {
      var a = item.querySelector('.pp-faq-a');
      var q = item.querySelector('.pp-faq-q');
      item.classList.add('is-open');
      q.setAttribute('aria-expanded', 'true');
      a.style.height = a.firstElementChild.offsetHeight + 'px';
      var done = function (e) {
        if (e.propertyName !== 'height') return;
        a.removeEventListener('transitionend', done);
        if (item.classList.contains('is-open')) a.style.height = 'auto';
      };
      a.addEventListener('transitionend', done);
    }

    items.forEach(function (item) {
      var q = item.querySelector('.pp-faq-q');
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (o) { if (o !== item && o.classList.contains('is-open')) close(o); });
        if (isOpen) close(item); else open(item);
      });
    });

    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        if (item.classList.contains('is-open')) item.querySelector('.pp-faq-a').style.height = 'auto';
      });
    });
  }

  /* ---------- 5 · Sayaç animasyonu (2500ms, kaynak ayarı) ---------- */
  function initCounters() {
    var nodes = Array.prototype.slice.call(scope.querySelectorAll('[data-pp-count]')); nodes = nodes.filter(function(n){if(!n.closest('[data-pp-motion="false"]'))return true;n.textContent=(n.getAttribute('data-pp-prefix')||'')+n.getAttribute('data-pp-count')+(n.getAttribute('data-pp-suffix')||'');return false;});
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.textContent = (n.getAttribute('data-pp-prefix') || '') + n.getAttribute('data-pp-count') + (n.getAttribute('data-pp-suffix') || ''); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-pp-count'));
        var suffix = el.getAttribute('data-pp-suffix') || '';
        var prefix = el.getAttribute('data-pp-prefix') || '';
        var dur = 2500, start = null;
        function step(ts) {
          if (start === null) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.35 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---------- 6 · Sepete ekleme ---------- */
  /* ---------- 7 · Stok sayacı ---------- */
  /* ---------- 8 · Satın alma kutusu yorum şeridi ---------- */
  function initBuyBoxReviews() {
    var el = scope.querySelector('[data-pp-buybox-reviews]');
    if (!el || typeof Swiper === 'undefined') return;
    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 12,
      autoHeight: true,
      speed: 350,
      loop: true,
      autoplay: reduce ? false : { delay: 5000, disableOnInteraction: true },
      navigation: { prevEl: '[data-pp-bbr-prev]', nextEl: '[data-pp-bbr-next]' },
      a11y: { enabled: true, prevSlideMessage: 'Önceki yorum', nextSlideMessage: 'Sonraki yorum' }
    });
  }

  /* ---------- 9 · Müşteri yorumları slider ---------- */
  function initReviewSlider() {
    var el = scope.querySelector('[data-pp-reviews]');
    if (!el || typeof Swiper === 'undefined') return;
    new Swiper(el, {
      slidesPerView: 1.1,
      spaceBetween: 16,
      speed: 400,
      navigation: { prevEl: '[data-pp-rev-prev]', nextEl: '[data-pp-rev-next]' },
      keyboard: { enabled: true, onlyInViewport: true },
      a11y: { enabled: true, prevSlideMessage: 'Önceki yorumlar', nextSlideMessage: 'Sonraki yorumlar' },
      breakpoints: { 640: { slidesPerView: 2, spaceBetween: 18 }, 1000: { slidesPerView: 3, spaceBetween: 20 } }
    });
  }

  /* ---------- 10 · Alıntı geçişi (Review Slider bölümü) ---------- */
  function initQuotes() {
    var wrap = scope.querySelector('[data-pp-quotes]');
    if (!wrap) return;
    var items = Array.prototype.slice.call(wrap.querySelectorAll('.pp-revsl-item'));
    var count = wrap.querySelector('[data-pp-q-count]');
    var prev = wrap.querySelector('[data-pp-q-prev]');
    var next = wrap.querySelector('[data-pp-q-next]');
    var i = 0;
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function show(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (el, k) { el.classList.toggle('is-active', k === i); });
      if (count) count.textContent = pad(i + 1) + ' \u2013 ' + pad(items.length);
    }
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    show(0);
  }

  function boot(event) {
    scope = event && event.type === "shopify:section:load" ? event.target : document;
    initGallery(); initRows(); initTabs(); initFaq(); initCounters();
    initBuyBoxReviews(); initReviewSlider(); initQuotes();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function(e){e.target.querySelectorAll('.swiper').forEach(function(el){if(el.swiper)el.swiper.destroy(true,true);});});
})();

 document.addEventListener('change',function(e){if(!e.target.matches('[data-pp-real-variant]'))return;var form=e.target.closest('form');var id=form.querySelector('input[name="id"]');id.value=e.target.value;id.dispatchEvent(new Event('change',{bubbles:true}));var url=new URL(location.href);url.searchParams.set('variant',id.value);location.href=url.href;});
document.addEventListener('click',function(e){var b=e.target.closest('[data-pp-burger]');if(b){var nav=document.querySelector('[data-pp-nav]');var open=nav.classList.toggle('is-open');b.setAttribute('aria-expanded',String(open));}var c=e.target.closest('[data-pp-scroll-atc]');if(c){document.querySelector('.pp-native-buy')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});}});


(function(){
 var cleanup;
 function setup(){
  if(cleanup){cleanup();cleanup=null;}
  document.querySelectorAll('[data-pp-motion="false"] .swiper').forEach(function(el){if(el.swiper){el.swiper.params.speed=0;if(el.swiper.autoplay)el.swiper.autoplay.stop();}});
  var bar=document.querySelector('[data-pp-sticky]'),anchor=document.querySelector('.pp-native-buy');
  if(!bar||!anchor)return;
  var scheduled=false;function measure(){scheduled=false;var visible=anchor.getBoundingClientRect().bottom<0;bar.classList.toggle('is-visible',visible);bar.setAttribute('aria-hidden',String(!visible));bar.inert=!visible;}
  function tick(){if(!scheduled){scheduled=true;requestAnimationFrame(measure);}}
  addEventListener('scroll',tick,{passive:true});addEventListener('resize',tick);measure();
  var stickyButton=bar.querySelector('button');
  function add(){var button=anchor.querySelector('button[type="submit"]');if(button&&!button.disabled)button.click();}
  stickyButton?.addEventListener('click',add);
  cleanup=function(){removeEventListener('scroll',tick);removeEventListener('resize',tick);stickyButton?.removeEventListener('click',add);};
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
 document.addEventListener('shopify:section:load',setup);
})();
